import React from "react";
import { InlineForm } from "./InlineForm";

type Props = {
  readOnlyRenderer: () => React.ReactElement<any>;
  isEditing: boolean;
  initialValue: string;
  onCancel: () => void;
  onSubmit: (text: string) => Promise<any>;
  submitOnCancel?: boolean;
};

export function InlineEditor(props: Props) {
  if (!props.isEditing) {
    return props.readOnlyRenderer();
  }

  return (
    <InlineForm
      onSubmit={(values) => props.onSubmit(values.text)}
      onCancel={props.onCancel}
      initialValue={{ text: props.initialValue }}
      submitOnCancel={props.submitOnCancel}
    />
  );
}
